export default {
  CTA: 'cta',
  UPLOAD: 'upload',
  CAMERA: 'camera',
  RESET_PIN: 'reset_pin',
  CAMERA_PERMISSION_EXPLANATION: 'camera_permission_explanation',
  DEMO_CREATE_PAYMENT: 'demo_create_payment',
  SHARE_DEMO_MODAL: 'share_demo_modal',
  DEMO_DIGITAL_WALLET: 'demo_digital_wallet',
  DEMO_AUTH_PAYMENT: 'demo_auth_payment'
};
